import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=1f182706&scoped=true&lang=pug&"
import script from "./InventoryTable.vue?vue&type=script&lang=js&"
export * from "./InventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTable.vue?vue&type=style&index=0&id=1f182706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f182706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VMenu,VSkeletonLoader,VSpacer})
